export default "* Instrumenter\n* Fortælling\n* Ritual\n* Ceremoni\n";